import type { SpaceType } from "@circle-react/types/Space";

import { t } from "@/i18n-js/instance";

export const SPACE_TYPE_FORM_ID = "create-space-v4-type-form";
export const COURSE_TYPE_FORM_ID = "create-space-v4-course-type-form";

export const STEP = {
  type: "type",
  course: "course",
  form: "form",
} as const;

export type SpaceIconType =
  | "notes"
  | "calendar"
  | "message-dots"
  | "graduate-cap"
  | "people"
  | "image";

export interface SpaceTypeOptionConfig {
  descriptionKey: string;
  getLabel: () => string;
  icon: SpaceIconType;
  value: SpaceType;
}

export const SPACE_TYPE_OPTIONS: readonly SpaceTypeOptionConfig[] = [
  {
    value: "basic",
    icon: "notes",
    getLabel: () => t("spaces.form.create.space_types.post_label"),
    descriptionKey: "spaces.form.create.v4.space_types.post_description",
  },
  {
    value: "chat",
    icon: "message-dots",
    getLabel: () => t("spaces.form.create.space_types.chat_label"),
    descriptionKey: "spaces.form.create.v4.space_types.chat_description",
  },
  {
    value: "course",
    icon: "graduate-cap",
    getLabel: () => t("spaces.form.create.space_types.course_label"),
    descriptionKey: "spaces.form.create.v4.space_types.course_description",
  },
  {
    value: "image",
    icon: "image",
    getLabel: () => t("spaces.form.create.space_types.image_label"),
    descriptionKey: "spaces.form.create.v4.space_types.image_description",
  },
  {
    value: "event",
    icon: "calendar",
    getLabel: () => t("spaces.form.create.space_types.event_label"),
    descriptionKey: "spaces.form.create.v4.space_types.event_description",
  },
  {
    value: "members",
    icon: "people",
    getLabel: () => t("spaces.form.create.space_types.members_label"),
    descriptionKey: "spaces.form.create.v4.space_types.members_description",
  },
];
